module.exports = __webpack_public_path__ + "media/images/backgrounds/ballistic-calculator-538d7cffa3808fd9f08ef12c920a3b3e7438265d6c650db56903cb3ac47ed45d.jpg";